// Candidate certificate
export const BASE_CANDIDATE_CERTIFICATE = "/api/certifications";

// Candidate work experience
export const BASE_CANDIDATE_WORK_EXPERIENCE = "/api/work-experience";

// Candidate education details
export const BASE_CANDIDATE_EDUCATION_DETAILS = "/api/education-details";

// Candidate Self-intro video
export const BASE_CANDIDATE_SELF_INTRO_VIDEO = "/api/candidates";

// Candidate Languages
export const BASE_CANDIDATE_LANGUAGES = "/api/languages";

// Candidate Public Email
export const BASE_CANDIDATE_PUBLIC = "/api/candidates/public"
